import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs'
import { ITextEntry } from './../models/text-dictionary.model';
import { ITextDictionary } from './../models/text-dictionary.model';
import { map, catchError } from 'rxjs/operators';
import textList from '../../assets/data/text-dictionary.json';


@Injectable({
  providedIn: 'root'
})
export class TextDictionaryService {
  dict=textList;
  constructor(private http:HttpClient) { 
    var myDict:ITextDictionary;
  }

  async getText(key:string){
    return key;
    let txt = await this.dict.find(kk=>kk.key===key).value;
    if(!txt){return key;}
    return txt;
  }
  // async getDictionary(){
  //   let myDict = await this.http.get<Array<string>[]>("assets/data/text-dictionary.json").pipe(
  //     map(kk=>[kk.keys,kk.values])
  //   );
  //   //let myDict = dictionary.values.map(kk=>[kk.key,kk.value] as [string,string]);
  //   // for(var kk=0; kk<dictionary.values.length; kk++) 
  //   // {
  //   //     this.dict[dictionary[kk].key] = dictionary[kk].value;
  //   // }
   
  //   return myDict;
  // }
}
